<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.DataAdjustment')"
    :width="$selectByLang('500px', '500px', '750px')"
    :close-on-click-modal="false"
  >
    <el-form :label-width="$selectByLang('70px', '70px', '110px')" label-position="left">
      <el-form-item :label="$t('Tool.PartnerCategory') + ':'">
        <el-cascader
          v-model="dataCategory"
          :options="dataCategoris"
          style="width: 100%;"
          @change="p => onDataCategoryChange(p)"
        />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'EQ_SIZE_TYPE'" :label="$t('SeaExport.OriginalData')">
        <div style="display: flex;">
          <div :style="$selectByLang('width: 65px', 'width: 65px', 'width: 250px')">{{ $t('SeaExport.ContainerSize') }}</div>
          <el-select v-model="originEqSize">
            <el-option v-for="(item, index) in eqSzies" :key="index" :label="item.name" :value="item.code" />
          </el-select>
          <div :style="'margin-left: 5px;' + $selectByLang('width: 65px', 'width: 65px', 'width: 250px')">{{ $t('SeaExport.ContainerType') }}</div>
          <el-select v-model="originEqType">
            <el-option v-for="(item, index) in eqTypes" :key="index" :value="item.code" />
          </el-select>
        </div>
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'EQ_SIZE_TYPE'" :label="$t('SeaExport.AfterAdjustment')">
        <div style="display: flex;">
          <div :style="$selectByLang('width: 65px', 'width: 65px', 'width: 250px')">{{ $t('SeaExport.ContainerSize') }}</div>
          <el-select v-model="newEqSize">
            <el-option v-for="(item, index) in eqSzies" :key="index" :label="item.name" :value="item.code" />
          </el-select>
          <div :style="'margin-left: 5px;' + $selectByLang('width: 65px', 'width: 65px', 'width: 250px')">{{ $t('SeaExport.ContainerType') }}</div>
          <el-select v-model="newEqType">
            <el-option v-for="(item, index) in eqTypes" :key="index" :value="item.code" />
          </el-select>
        </div>
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'CONTAINER_AND_SEAL_NO_TYPE'" :label="$t('SeaExport.AfterAdjustment')">
        <div style="display: flex;">
          <el-input v-model="containerNo" :disabled="clearByBusiness" :placeholder="clearByBusiness ? '' : $t('SeaExport.inputContainerNo')" />
          <el-input v-model="sealNo" :disabled="clearByBusiness" :placeholder="clearByBusiness ? '' : $t('SeaExport.inputSealNo')" />
        </div>
        <div>
          {{ $t('CargoMsg.Cargo_ClearData') + ':' }}
          <el-checkbox v-model="clearByBusiness" @change="onClearByBusinessChange()" />
        </div>
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'CATEGORY_OF_GOODS_TYPE'" :label="$t('SeaExport.AfterAdjustment')">
        <div style="display: flex;">
          <cargo-advance-select
            no="cargoCode"
            :disabled="clearByBusiness"
            :select-type="selectTypeNames.basic_data_CargoInformation"
            filterable
            :clearable="true"
            :default-value="cargoCode"
            :placeholder="$t('SeaExport.PleaseSelectCategory')"
            :allow-create="false"
            @parentCallBack="p => { cargoCodeChange(p.value) }"
          />
        </div>
        <div>
          {{ $t('CargoMsg.Cargo_ClearData') + ':' }}
          <el-checkbox v-model="clearByBusiness" :disabled="dataCategoryValue === 'BUSINESS_OP_TYPE' || dataCategoryValue === 'BUSINESS_SALES_TYPE'" @change="onClearByBusinessChange()" />
        </div>
      </el-form-item>

      <el-form-item v-if="dataCategoryValue === 'IC_CARRIER_COMPANY'" :label="$t('SeaExport.AfterAdjustment')">
        <div style="display: flex;">
          <cargo-company-select
            no="icCarrierCompany"
            :disabled="clearByBusiness"
            :method-params="{truckCmp:true,active:true,companyLob:'integratedJob'}"
            :default-value="icCarrierCompanyValue||''"
            :placeholder="$t('SeaExport.PleaseSelect') + $t('SeaExport.Carrier')"
            @change="p => { icCarrierCompanyValue = p.value }"
          />
        </div>
        <div>
          {{ $t('CargoMsg.Cargo_ClearData') + ':' }}
          <el-checkbox v-model="clearByBusiness" @change="onClearByBusinessChange()" />
        </div>
      </el-form-item>

      <el-form-item v-if="dataCategoryValue === 'IC_BOOKING_AGENT'" :label="$t('SeaExport.AfterAdjustment')">
        <div style="display: flex;">
          <cargo-advance-select
            no="icBookingAgent"
            :disabled="clearByBusiness"
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{bookingAgent:true,companyLob:'integratedJob',active:true}"
            filterable
            :clearable="true"
            :default-value="icBookingAgentValue||''"
            :placeholder="$t('SeaExport.PleaseSelect') + $t('SeaExport.BookingAgent')"
            @parentCallBack="p => { icBookingAgentValue = p.value }"
          />
        </div>
        <div>
          {{ $t('CargoMsg.Cargo_ClearData') + ':' }}
          <el-checkbox v-model="clearByBusiness" @change="onClearByBusinessChange()" />
        </div>
      </el-form-item>

      <el-form-item v-if="dataCategoryValue === 'IC_WAREHOUSE_SUPPLIER'" :label="$t('SeaExport.AfterAdjustment')">
        <div style="display: flex;">
          <cargo-company-select
            no="icWarehouseSupplier"
            :disabled="clearByBusiness"
            :method-params="{warehouse:true,active:true,companyLob:'integratedJob'}"
            :default-value="icWarehouseSupplierValue||''"
            :placeholder="$t('SeaExport.PleaseSelect') + $t('SeaExport.WarehouseSupplier')"
            @change="p => { icWarehouseSupplierValue = p.value }"
          />
        </div>
        <div>
          {{ $t('CargoMsg.Cargo_ClearData') + ':' }}
          <el-checkbox v-model="clearByBusiness" @change="onClearByBusinessChange()" />
        </div>
      </el-form-item>

      <el-form-item v-if="!(isXycw && lob === 'SE') && dataCategoryValue === 'ETA_DATE_TYPE'" :label="$t('SeaExport.AfterAdjustment')">
        <div style="display: flex;">
          <el-date-picker
            v-if="lob === 'SE'"
            v-model="unBerthPlanDate"
            no="unBerthPlanDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.PlanDepartureTime')"
            style="width: 100%"
          />
          <el-date-picker
            v-if="lob === 'AE'"
            v-model="estimatedDepartureTime"
            no="estimatedDepartureTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('CargoMsg.Cargo_EstimatedDepartureTime')"
            style="width: 100%"
          />
          <el-date-picker
            v-model="estimatedArrivalTime"
            no="estimatedArrivalTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + (lob === 'SE' ? $t('SeaExport.EstimatedArrivalTime') : $t('CargoMsg.Cargo_EstimatedArrivalTime'))"
            style="width: 100%"
          />
        </div>
      </el-form-item>

      <!--当前计划离泊时间(Current ETD)/当前计划到港时间(Current ETA)-->
      <el-form-item v-if="isXycw && lob === 'SE' && dataCategoryValue === 'CUR_ETA_DATE_TYPE'" :label="$t('SeaExport.AfterAdjustment')">
        <div style="display: flex;">
          <el-date-picker
            v-model="currentETD"
            no="currentETD"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.NowPlanDepartureTime')"
            style="width: 100%"
          />
          <el-date-picker
            v-model="currentArrivalETA"
            no="currentArrivalETA"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.CurrentETA')"
            style="width: 100%"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'ATD_ATA_DATE_TYPE'" :label="$t('SeaExport.AfterAdjustment')">
        <div style="display: flex;">
          <el-date-picker
            v-if="lob === 'SE'"
            v-model="actualUnBerthPlanDate"
            no="actualUnBerthPlanDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.RealDepartureTime')"
            style="width: 100%"
          />
          <el-date-picker
            v-if="lob === 'AE'"
            v-model="actualDepartureTime"
            no="actualDepartureTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('CargoMsg.Cargo_ActualDepartureTime')"
            style="width: 100%"
          />
          <el-date-picker
            v-if="lob === 'SE'"
            v-model="actualArrivalTime"
            no="actualArrivalTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.ArrivalTime')"
            style="width: 100%"
          />

          <el-date-picker
            v-if="lob === 'AE'"
            v-model="actualArrivalTime"
            no="actualArrivalTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('CargoMsg.Cargo_ActualArrivalTime')"
            style="width: 100%"
          />
        </div>
      </el-form-item>
      <!--原始计划离泊时间(Original ETD)/原始计划到港时间(Original ETA)-->
      <el-form-item v-if="isXycw && lob === 'SE' && dataCategoryValue === 'ORIGINAL_ETA_DATE_TYPE'" :label="$t('SeaExport.AfterAdjustment')">
        <div style="display: flex;">
          <el-date-picker
            v-model="unBerthPlanDate"
            no="unBerthPlanDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.OriginalPlanDepartureTime')"
            style="width: 100%"
          />
          <el-date-picker
            v-model="estimatedArrivalTime"
            no="estimatedArrivalTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.OriginalETA')"
            style="width: 100%"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="isBusinessPeople" :label="$t('SeaExport.AfterAdjustment')">
        <!-- 操作 -->
        <div v-if="dataCategoryValue === 'BUSINESS_OP_TYPE'" style="display: flex;">
          <cargo-user-select
            ref="op"
            no="op"
            :disabled="clearByBusiness"
            :method-params="{officeId:job.opOffice, category:'role', shape:'op'}"
            :default-value="userId || ''"
            :placeholder="$t('SeaExport.PleaseSelectAction')"
            :merge-load="true"
            @change="p => {userId = p.value; businessPeopleChangeHandler(p, 'op')}"
          />
          <cargo-department-select
            no="opDepartment"
            :disabled="clearByBusiness"
            :office-id="Number(job.opOffice)"
            :enables="true"
            :placeholder="$t('SeaExport.PleaseSelectOpDep')"
            :department-id="Number(depId)"
            @change="p => {depId = p.value}"
          />
        </div>
        <!-- 销售 -->
        <div v-if="dataCategoryValue === 'BUSINESS_SALES_TYPE'" style="display: flex;">
          <cargo-user-select
            ref="sales"
            no="sales"
            :disabled="clearByBusiness"
            :method-params="{officeId:job.opOffice, category:'role', shape:'sales'}"
            :default-value="userId || ''"
            :placeholder="$t('CargoMsg.Cargo_SelectSalesPerson')"
            :merge-load="true"
            @change="p => {userId = p.value; businessPeopleChangeHandler(p, 'sales')}"
          />&nbsp;
          <cargo-department-select
            no="opDepartment"
            :disabled="clearByBusiness"
            :office-id="Number(job.opOffice)"
            :enables="true"
            :placeholder="$t('CargoMsg.Cargo_SelectSalesPersonDep')"
            :department-id="Number(depId)"
            @change="p=>{depId = p.value}"
          />
        </div>
        <!-- 客服 -->
        <div v-if="dataCategoryValue === 'BUSINESS_CSR_TYPE'" style="display: flex;">
          <cargo-user-select
            ref="csr"
            no="csr"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_SelectCsr')"
            :method-params="{officeId:job.opOffice, category:'role', shape:'csr'}"
            :default-value="userId || ''"
            :merge-load="true"
            @change="p => {userId = p.value; businessPeopleChangeHandler(p, 'csr')}"
          />
          <cargo-department-select
            no="opDepartment"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_SelectCsrDep')"
            :office-id="Number(job.opOffice)"
            :enables="true"
            :department-id="Number(depId)"
            @change="p=>{depId = p.value}"
          />
        </div>
        <!-- 单证 -->
        <div v-if="dataCategoryValue === 'BUSINESS_DC_TYPE'" style="display: flex;">
          <cargo-user-select
            ref="dc"
            no="dc"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_SelectDoc')"
            :method-params="{officeId:job.opOffice, category:'role',shape:'doc'}"
            :default-value="userId || ''"
            :merge-load="true"
            @change="p => {userId = p.value; businessPeopleChangeHandler(p, 'doc')}"
          />
          <cargo-department-select
            no="opDepartment"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_SelectDocDep')"
            :office-id="Number(job.opOffice)"
            :enables="true"
            :department-id="Number(depId)"
            @change="p=>{depId = p.value}"
          />
        </div>
        <!-- 海外客服 -->
        <div v-if="dataCategoryValue === 'BUSINESS_OVERSEA_OP_TYPE'" style="display: flex;">
          <cargo-user-select
            ref="overseaOp"
            no="overseaOp"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_SelectOverseaOp')"
            :default-value="userId || ''"
            :static-options="overseaAgentUsersList"
            :merge-load="true"
            @change="p=>{userId = p.value; businessPeopleChangeHandler(p, 'overseaOp')}"
          />
          <cargo-department-select
            no="opDepartment"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_SelectOverseaOpDep')"
            :office-id="Number(job.opOffice)"
            :enables="true"
            :department-id="Number(depId)"
            @change="p=>{depId = p.value}"
          />
        </div>
        <!-- 揽货销售 -->
        <div v-if="dataCategoryValue === 'BUSINESS_CARGO_SALES_TYPE'" style="display: flex;">
          <cargo-user-select
            no="cargoSalesId"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_SelectCargoSales')"
            :method-params="{category:'role', shape:'salesOfGoods'}"
            :default-value="userId || ''"
            :merge-load="true"
            @change="p=>{userId = p.value}"
          />
        </div>
        <!-- 用户自定义角色1 -->
        <div v-if="dataCategoryValue === 'BUSINESS_UDR1_TYPE'" style="display: flex;">
          <cargo-user-select
            no="userDefinedRoleId1"
            :disabled="clearByBusiness"
            :placeholder="$t('SeaExport.UserDefinedRole1')"
            :method-params="{category:'role', shape:'userDefinedRole1'}"
            :default-value="userId || ''"
            :merge-load="true"
            @change="p=>{userId = p.value; businessPeopleChangeHandler(p, 'userDefinedRole1')}"
          />
        </div>
        <!-- 用户自定义角色2 -->
        <div v-if="dataCategoryValue === 'BUSINESS_UDR2_TYPE'" style="display: flex;">
          <cargo-user-select
            no="userDefinedRoleId2"
            :disabled="clearByBusiness"
            :placeholder="$t('SeaExport.UserDefinedRole2')"
            :method-params="{category:'role', shape:'userDefinedRole2'}"
            :default-value="userId || ''"
            :merge-load="true"
            @change="p=>{userId = p.value; businessPeopleChangeHandler(p, 'userDefinedRole2')}"
          />
        </div>
        <!-- 用户自定义角色3 -->
        <div v-if="dataCategoryValue === 'BUSINESS_UDR3_TYPE'" style="display: flex;">
          <cargo-user-select
            no="userDefinedRoleId3"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_userDefinedRole3')"
            :method-params="{category:'role', shape:'userDefinedRole3'}"
            :default-value="userId || ''"
            :merge-load="true"
            @change="p=>{userId = p.value; businessPeopleChangeHandler(p, 'userDefinedRole3')}"
          />
        </div>
        <!-- 用户自定义角色4 -->
        <div v-if="dataCategoryValue === 'BUSINESS_UDR4_TYPE'" style="display: flex;">
          <cargo-user-select
            no="userDefinedRoleId4"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_userDefinedRole4')"
            :method-params="{category:'role', shape:'userDefinedRole4'}"
            :default-value="userId || ''"
            :merge-load="true"
            @change="p=>{userId = p.value; businessPeopleChangeHandler(p, 'userDefinedRole4')}"
          />
        </div>
        <!-- 用户自定义角色5 -->
        <div v-if="dataCategoryValue === 'BUSINESS_UDR5_TYPE'" style="display: flex;">
          <cargo-user-select
            no="userDefinedRoleId5"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_userDefinedRole5')"
            :method-params="{category:'role', shape:'userDefinedRole5'}"
            :default-value="userId || ''"
            :merge-load="true"
            @change="p=>{userId = p.value; businessPeopleChangeHandler(p, 'userDefinedRole5')}"
          />
        </div>
        <!-- 用户自定义角色6 -->
        <div v-if="dataCategoryValue === 'BUSINESS_UDR6_TYPE'" style="display: flex;">
          <cargo-user-select
            no="userDefinedRoleId6"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_userDefinedRole6')"
            :method-params="{category:'role', shape:'userDefinedRole6'}"
            :default-value="userId || ''"
            :merge-load="true"
            @change="p=>{userId = p.value; businessPeopleChangeHandler(p, 'userDefinedRole6')}"
          />
        </div>
        <!-- 用户自定义角色7 -->
        <div v-if="dataCategoryValue === 'BUSINESS_UDR7_TYPE'" style="display: flex;">
          <cargo-user-select
            no="userDefinedRoleId7"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_userDefinedRole7')"
            :method-params="{category:'role', shape:'userDefinedRole7'}"
            :default-value="userId || ''"
            :merge-load="true"
            @change="p=>{userId = p.value; businessPeopleChangeHandler(p, 'userDefinedRole7')}"
          />
        </div>
        <!--港前商务负责人-->
        <div v-if="dataCategoryValue === 'BUSINESS_PRE_PORT_PLANNER_TYPE'" style="display: flex;">
          <cargo-user-select
            no="prePortPlanner"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_PrePortBusinessLeader')"
            :method-params="{category:'role',shape:'sealine',officeId:job.opOffice}"
            :default-value="userId||''"
            :merge-load="true"
            @change="p=>{userId = p.value; businessPeopleChangeHandler(p, 'seaLine')}"
          />
        </div>
        <!--尾程商务负责人-->
        <div v-if="dataCategoryValue === 'BUSINESS_LAST_MILE_PLANNER_TYPE'" style="display: flex;">
          <cargo-user-select
            no="lastMilePlanner"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_LastMileBusinessLeader')"
            :method-params="{category:'role',shape:'sealine',officeId:job.opOffice}"
            :default-value="userId||''"
            :merge-load="true"
            @change="p=>{userId = p.value; businessPeopleChangeHandler(p, 'seaLine')}"
          />
        </div>
        <!-- 航线负责人 -->
        <div v-if="dataCategoryValue === 'BUSINESS_PLANNER_TYPE'" style="display: flex;">
          <cargo-user-select
            no="planner"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_SelectPlanner')"
            :method-params="{officeId:job.opOffice, category:'role', shape:'seaLine'}"
            :default-value="userId || ''"
            :merge-load="true"
            @change="p=>{userId = p.value; businessPeopleChangeHandler(p, 'seaLine')}"
          />
          <cargo-department-select
            no="opDepartment"
            :disabled="clearByBusiness"
            :placeholder="$t('CargoMsg.Cargo_SelectPlannerDep')"
            :office-id="Number(job.opOffice)"
            :enables="true"
            :department-id="Number(depId)"
            @change="p=>{depId = p.value}"
          />
        </div>
        <div>
          {{ $t('CargoMsg.Cargo_ClearData') + ':' }}
          <el-checkbox v-model="clearByBusiness" :disabled="dataCategoryValue === 'BUSINESS_OP_TYPE' || dataCategoryValue === 'BUSINESS_SALES_TYPE'" @change="onClearByBusinessChange()" />
        </div>
      </el-form-item>
      <el-form-item v-if="isLocalService">
        <span>{{ $t('SeaExport.CheckStatuses') }}</span>
        <el-checkbox v-model="localService.checkState" :disabled="localService.clearCheck" />
        <span>{{ $t('SeaExport.ClearStatuses') }}</span>
        <el-checkbox v-model="localService.clearCheck" @change="val=>{if(val){localService.checkState=false}}" />
      </el-form-item>
      <el-form-item v-if="isDestinationPortService">
        <span>{{ $t('SeaExport.CheckStatuses') }}</span>
        <el-checkbox v-model="destinationPortService.checkState" :disabled="destinationPortService.clearCheck" />
        <span>{{ $t('SeaExport.ClearStatuses') }}</span>
        <el-checkbox v-model="destinationPortService.clearCheck" @change="val=>{if(val){destinationPortService.checkState=false}}" />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'USER_DEFINED_FIELD1'" :label="$t('SeaExport.AfterAdjustment')">
        <el-input
          v-model="userDefinedField1"
          :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.UserDefinedField1')"
        />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'USER_DEFINED_FIELD2'" :label="$t('SeaExport.AfterAdjustment')">
        <el-input
          v-model="userDefinedField2"
          :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.UserDefinedField2')"
        />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'USER_DEFINED_FIELD3'" :label="$t('SeaExport.AfterAdjustment')">
        <el-input
          v-model="userDefinedField3"
          :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.UserDefinedField3')"
        />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'USER_DEFINED_FIELD4'" :label="$t('SeaExport.AfterAdjustment')">
        <el-input
          v-model="userDefinedField4"
          :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.UserDefinedField4')"
        />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'WAREHOUSE_CMP'" :label="$t('SeaExport.AfterAdjustment')">
        <div style="display: flex;">
          <cargo-company-select
            :method-params="{warehouse:true,active:true}"
            :default-value="warehouseCmp||''"
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + (isOpenWarehouse ? $t('SeaExport.WarehouseSupplier') : $t('CargoMsg.Cargo_Warehouse'))"
            style="width: 100%"
            @change="p=>{warehouseCmp=p.value||0;warehouseChangeHandler(p.value)}"
          />
          <el-select
            v-if="isOpenWarehouse"
            v-model="warehouseName"
            :allow-create="true"
            filterable
            :clearable="true"
            style="width: 100%"
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.WareHouseName')"
          >
            <el-option
              v-for="(item,index) in warehouseNameList"
              :key="index"
              :label="item.warehouseName"
              :value="item.warehouseName"
            />
          </el-select>
        </div>
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'MBL_NO'" :label="$t('SeaExport.AfterAdjustment')">
        <!--        <el-input-->
        <!--          v-model="mblNo"-->
        <!--          :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.Mbl2')"-->
        <!--        />-->
        <mawb-no-input
          ref="mawbNoInput"
          v-model="mblNo"
          :editable="false"
        />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'CARRIER_ID'" :label="$t('SeaExport.AfterAdjustment')">
        <cargo-advance-select
          no="41"
          filterable
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{airCmp:true, companyLob:'airExport',active:true}"
          :default-value="carrierId||''"
          :headers="[$t('Tool.ShortName'),$t('Partners.chineseName')]"
          :fields="['shortName', 'chineseName']"
          :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.AirlineCompany')"
          @parentCallBack="p => {carrierId=p.value||0}"
        />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'VOYAGE_FLIGHT'" :label="$t('SeaExport.AfterAdjustment')">
        <el-input
          v-model="voyageFlight"
          :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.Flight')"
        />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'ESTIMATED_DELIVERY_TIME'" :label="$t('SeaExport.AfterAdjustment')">
        <el-date-picker
          v-model="estimatedDeliveryTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('CargoMsg.Cargo_EstimatedDeliveryTime')"
          style="width: 100%"
          clearable
        />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'ETD'" :label="$t('SeaExport.AfterAdjustment')">
        <el-date-picker
          v-model="etd"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm"
          format="yyyy-MM-dd HH:mm"
          :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.DateOfDeparture')"
          style="width: 100%"
          clearable
        />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'ETA'" :label="$t('SeaExport.AfterAdjustment')">
        <el-date-picker
          v-model="eta"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm"
          format="yyyy-MM-dd HH:mm"
          :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.DateOfArrival')"
          style="width: 100%"
          clearable
        />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'REMARKS'" :label="$t('SeaExport.AfterAdjustment')">
        <el-input
          v-model="remarks"
          type="textarea"
          :rows="4"
          :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('SeaExport.Remarks')"
        />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'BOOKING_AGENT'" :label="$t('SeaExport.AfterAdjustment')">
        <cargo-advance-select
          no="19"
          filterable
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{bookingAgent:true, active: true}"
          :default-value="bookingAgent||''"
          placeholder=" "
          @parentCallBack="p=>{bookingAgent=p.cmpIdx}"
        />
      </el-form-item>
      <el-form-item v-if="dataCategoryValue === 'DESTINATION_AGENT'" :label="$t('SeaExport.AfterAdjustment')">
        <div style="display: flex;">
          <cargo-advance-select
            no="destinationAgent"
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{overseaAgent:true,companyLob:'seaExport',active:true}"
            :default-value="destinationAgent||''"
            :disabled="clearByBusiness"
            filterable
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"
            @parentCallBack="p=>{destinationAgent=p.cmpIdx}"
          />
        </div>
        <div>
          {{ $t('CargoMsg.Cargo_ClearData') + ':' }}
          <el-checkbox v-model="clearByBusiness" @change="onClearByBusinessChange()" />
        </div>
      </el-form-item>

      <el-form-item v-if="dataCategoryValue === 'TRUCKING_CMP'" :label="$t('SeaExport.AfterAdjustment')">
        <div style="display: flex;">
          <cargo-company-select
            no="carryingCmp"
            :method-params="{truckCmp:true,active:true}"
            :default-value="carryingCmp||''"
            :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
            @change="p => { carryingCmp = p.value || 0 }"
          />
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button v-if="dataCategoryValue === 'EQ_SIZE_TYPE'" type="primary" @click="confirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="isBusinessPeople" type="primary" @click="businessConfirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'CATEGORY_OF_GOODS_TYPE'" type="primary" @click="categoryConfirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'ETA_DATE_TYPE'" type="primary" @click="updateDateConfirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'CUR_ETA_DATE_TYPE'" type="primary" @click="updateCurDateHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'ATD_ATA_DATE_TYPE'" type="primary" @click="updateAtdAtaDateConfirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'ORIGINAL_ETA_DATE_TYPE'" type="primary" @click="updateOriginalDateHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'CONTAINER_AND_SEAL_NO_TYPE'" type="primary" @click="containerConfirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'USER_DEFINED_FIELD1'" type="primary" @click="userDefinedFieldHandler('userDefinedField1', userDefinedField1)">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'USER_DEFINED_FIELD2'" type="primary" @click="userDefinedFieldHandler('userDefinedField2', userDefinedField2)">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'USER_DEFINED_FIELD3'" type="primary" @click="userDefinedFieldHandler('userDefinedField3', userDefinedField3)">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'USER_DEFINED_FIELD4'" type="primary" @click="userDefinedFieldHandler('userDefinedField4', userDefinedField4)">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'WAREHOUSE_CMP'" type="primary" @click="updateWarehouseDataConfirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'MBL_NO'" type="primary" @click="userDefinedFieldHandler('mblNo', mblNo)">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'CARRIER_ID'" type="primary" @click="updateCarrierIdConfirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'VOYAGE_FLIGHT'" type="primary" @click="userDefinedFieldHandler('voyageFlight', voyageFlight)">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'ESTIMATED_DELIVERY_TIME'" type="primary" @click="userDefinedFieldHandler('estimatedDeliveryTime', estimatedDeliveryTime)">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'ETD'" type="primary" @click="userDefinedFieldHandler('etd', etd)">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'ETA'" type="primary" @click="userDefinedFieldHandler('eta', eta)">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'REMARKS'" type="primary" @click="batchUpdateJobData">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="isLocalService" type="primary" @click="localServiceConfirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="isDestinationPortService" type="primary" @click="destinationPortServiceConfirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'BOOKING_AGENT'" type="primary" @click="bookingAgentConfirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'DESTINATION_AGENT'" type="primary" @click="destinationAgentConfirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'IC_CARRIER_COMPANY'" type="primary" @click="icDataTypeConfirmHandler('CARRIER_COMPANY')">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'IC_BOOKING_AGENT'" type="primary" @click="icDataTypeConfirmHandler('BOOKING_AGENT')">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'IC_WAREHOUSE_SUPPLIER'" type="primary" @click="icDataTypeConfirmHandler('WAREHOUSE_SUPPLIER')">{{ $t('common.btn.confirm') }}</el-button>
      <el-button v-if="dataCategoryValue === 'TRUCKING_CMP'" type="primary" @click="carryingCmpConfirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="innerVisible = false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
    <el-form v-if="dataCategoryValue === 'CUSTOMS' && localService.checkState === true" :label-width="$selectByLang('70px', '70px', '110px')" label-position="left">
      <el-form-item :label="$t('SeaExport.CustomsBroker') + ':'" class="custom">
        <cargo-advance-select
          no="customsBroker"
          :select-type="selectTypeNames.basic_data_Company"
          :data-filter-function="customsBrokerFilter"
          filterable
          :default-value="''"
          :method-params="{customsBroker:true,companyLob:'seaExport',active:true}"
          @parentCallBack="p=>{customsBroker = p.value || 0}"
        />
      </el-form-item>
    </el-form>
    <!-- 部分成功、部分失败弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="failDialog.visible"
      :title="$t('Message.Prompt')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-input v-model="failDialog.content" :disabled="true" type="textarea" :rows="10" />
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="copyFailJobNos">{{ $t('SeaExport.CopyFailedBusinessNumber') }}</el-button>
        <el-button @click="failDialog.visible = false">{{ $t('Message.Close') }}</el-button>
      </div>
    </el-dialog>
    <!-- 运输公司批量调整-门点装箱/提货校验弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="carryingCmpBlockDialog.visible"
      :title="$t('Message.Prompt')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div>{{ $t('SeaExport.CarryingCmpAdjustBlockedTip') }}</div>
      <div style="margin: 8px 0 4px;">{{ $t('SeaExport.AbnormalBusinessNo') }}</div>
      <div style="max-height: 200px; overflow-y: auto; border: 1px solid #ebeef5; border-radius: 4px; padding: 4px 8px;">
        <div v-for="jobNo in carryingCmpBlockDialog.jobNos" :key="jobNo">{{ jobNo }}</div>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="carryingCmpBlockDialog.visible = false">{{ $t('Message.Close') }}</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey, getObjectByCache } from '@/utils/basicDataCache'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { EQ_SIZES } from '@/class/cargo/model/parameters/EQSize'
import {
  batchUpdateContainerAndSealNo,
  batchUpdateEqSizeType,
  batchUpdateLocalService,
  batchUpdateDestinationPortService,
  batchUpdateDestinationAgentFunc,
  batchUpdateCarryingCmpFunc
} from '@/api/seaExport/seaExportJob'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect.vue'
import { User } from '@/class/model/sys/User'
import { basicCacheKeys } from '@/utils/cacheConfig'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import {
  batchUpdateAtdAtaDateFunc,
  batchUpdateBusinessPeopleType,
  batchUpdateCategoryOfGoodsType,
  batchUpdateCurDateFunc,
  batchUpdateDateFunc,
  batchUpdateOriginalDateFunc,
  batchUpdateJobDataFunc,
  batchUpdateBookingAgent,
  validateBatchBookingAgent,
  batchUpdateDataType
} from '@/api/booking/job'
import * as SeaExportConstants from '@/class/cargo/model/parameters/ContainerLoadType'
import { cache } from '@/utils/cacheManager'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import { batchUpdateAeJob, batchUpdateAeJobCarrierId, batchUpdateAeJobWarehouse } from '@/api/AirExport/airExportJob'
import { getWarehouseDetail } from '@/api/company'
import mawbNoInput from '@/components/Cargo/Job/mawbNoInput.vue'
import { Company } from '@/class/model/mdm/Company'
import { getAirlineList } from '@/api/partner/airline'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { TabError } from '@/utils/class/TabError'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'

export default {
  name: 'BatchModifyBusinessDialog',
  components: {
    mawbNoInput,
    cargoCompanySelect,
    CargoAdvanceSelect,
    cargoUserSelect,
    cargoDepartmentSelect
  },
  props: {
    visible: { type: Boolean, required: true },
    jobList: { type: Array, required: true },
    jobKeys: { type: Array, default: () => [] },
    lob: { type: String, required: true },
    integratedLogisticsType: { type: String, default: '' }
  },
  data() {
    return {
      uiCustomElementMap: new Map(),
      innerVisible: false,
      dataCategoris: [],
      selectTypeNames: TYPE_NAMES,
      eqSzies: EQ_SIZES,
      eqTypes: getCacheListByKey(TYPE_NAMES.basic_data_EQType),
      dataCategory: [],
      dataCategoryValue: '',
      originEqSize: '',
      originEqType: '',
      newEqSize: '',
      newEqType: '',
      containerNo: '',
      sealNo: '',
      job: null,
      cargoCode: '',
      cargoName: '',
      userId: '',
      depId: '',
      officeId: '',
      overseaAgentUsersList: [],
      clearByBusiness: false,
      unBerthPlanDate: null,
      estimatedArrivalTime: null,
      estimatedDepartureTime: null,
      currentETD: null, // 当前计划离泊时间
      currentArrivalETA: null, // 当前计划到港时间
      actualUnBerthPlanDate: null, // 实际离泊时间
      actualDepartureTime: null, // 实际起飞时间
      actualArrivalTime: null, // 实际抵达时间
      hasUpdate: false, // 是否有更新数据
      failDialog: {
        visible: false,
        content: '',
        jobNos: ''
      },
      localService: {
        checkState: false,
        clearCheck: false
      },
      destinationPortService: {
        checkState: false,
        clearCheck: false
      },
      customsBroker: 0,
      isOpenWarehouse: false,
      isXycw: false,
      warehouseLabel: '',
      warehouseNameList: [],
      userDefinedField1: '', // 自定义字段1
      userDefinedField2: '', // 自定义字段2
      userDefinedField3: '', // 自定义字段3
      userDefinedField4: '', // 自定义字段4
      warehouseCmp: 0, // 仓库名称
      warehouseName: '',
      mblNo: '', // 主单号
      carrierId: 0, // 航空公司
      voyageFlight: '', // 航班
      estimatedDeliveryTime: null, // 预计出库时间
      etd: null, // 开航日期
      eta: null, // 到港日期
      bookingAgent: 0, // 订舱代理
      destinationAgent: 0, // 目的港代理
      carryingCmp: 0, // 运输公司
      carryingCmpBlockDialog: {
        visible: false,
        jobNos: []
      },
      remarks: '' // 备注
    }
  },
  computed: {
    isBusinessPeople() {
      return this.dataCategoryValue === 'BUSINESS_OP_TYPE' || this.dataCategoryValue === 'BUSINESS_SALES_TYPE' || this.dataCategoryValue === 'BUSINESS_CSR_TYPE' || this.dataCategoryValue === 'BUSINESS_DC_TYPE' ||
          this.dataCategoryValue === 'BUSINESS_OVERSEA_OP_TYPE' || this.dataCategoryValue === 'BUSINESS_CARGO_SALES_TYPE' || this.dataCategoryValue === 'BUSINESS_PLANNER_TYPE' ||
          this.dataCategoryValue === 'BUSINESS_UDR1_TYPE' || this.dataCategoryValue === 'BUSINESS_UDR2_TYPE' || this.dataCategoryValue === 'BUSINESS_UDR3_TYPE' || this.dataCategoryValue === 'BUSINESS_UDR4_TYPE' ||
          this.dataCategoryValue === 'BUSINESS_UDR5_TYPE' || this.dataCategoryValue === 'BUSINESS_UDR6_TYPE' || this.dataCategoryValue === 'BUSINESS_UDR7_TYPE' ||
          this.dataCategoryValue === 'BUSINESS_PRE_PORT_PLANNER_TYPE' || this.dataCategoryValue === 'BUSINESS_LAST_MILE_PLANNER_TYPE'
    },
    isLocalService() {
      return this.dataCategoryValue === 'WAREHOUSING' || this.dataCategoryValue === 'LAND_TRANSPORTATION' || this.dataCategoryValue === 'SELF_DELIVER' ||
          this.dataCategoryValue === 'BACK_UP_WAREHOUSE' || this.dataCategoryValue === 'CUSTOMS' || this.dataCategoryValue === 'Booking'
    },
    isDestinationPortService() {
      return this.dataCategoryValue === 'DISCHARGING_PORT_DOOR' || this.dataCategoryValue === 'US_CUSTOMS_CLEARANCE'
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.initData()
        this.innerVisible = newVal
        if (newVal) {
          if (this.$checkPermission(['button_SEBooking_BatchUpdateEqSize']) || this.$checkPermission(['button_SIBooking_BatchUpdateEqSize']) || this.$checkPermission(['button_REBooking_BatchUpdateEqSize'])) {
            this.dataCategory = ['EQ_SIZE_TYPE']
            this.dataCategoryValue = 'EQ_SIZE_TYPE'
            this.originEqSize = this.newEqSize = this.eqSzies[0].code
            if (this.eqTypes.length) {
              if (this.eqTypes.findIndex(p => p.code === 'GP') > -1) {
                this.originEqType = this.newEqType = 'GP'
              } else {
                this.originEqType = this.newEqType = this.eqTypes[0].code
              }
            } else {
              this.originEqType = this.newEqType = ''
            }
          }
          this.hasUpdate = false
          this.init()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        if (this.hasUpdate) {
          this.$emit('callback')
        }
      }
    }
  },
  methods: {
    async init() {
      this.userId = ''
      this.depId = ''
      this.officeId = ''
      this.job = null
      this.dataCategoris = []
      let lob = this.lob
      if (lob === 'IE') {
        if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_TT.code) {
          lob = SeaExportConstants.STUFFY_TT.code
        } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_IC.code) {
          lob = SeaExportConstants.STUFFY_IC.code
        } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_CL.code) {
          lob = SeaExportConstants.STUFFY_CL.code
        }
      }
      UICustomUtil.initUiCustomElementMap(lob, this.$store.getters.currentOfficeId, this.uiCustomElementMap)
      console.log('this.uiCustomElementMap:', this.uiCustomElementMap)
      await this.initConfig()
      this.initDataCategoris()
      await this.getOverseaAgentUserByConfig()
    },
    async initConfig() {
      this.isOpenWarehouse = parseInt(cache.config.get('isOpenWarehouse')) > 0
      this.isXycw = String(cache.config.get('ToExoSystem')) === 'XYCW'
    },
    initData() {
      this.cargoCode = ''
      this.dataCategory = []
      this.dataCategoryValue = ''
      this.originEqSize = ''
      this.originEqType = ''
      this.newEqSize = ''
      this.newEqType = ''
      this.containerNo = ''
      this.sealNo = ''
      this.job = null
      this.cargoCode = ''
      this.cargoName = ''
      this.userId = ''
      this.depId = ''
      this.officeId = ''
      this.unBerthPlanDate = null
      this.estimatedArrivalTime = null
      this.estimatedDepartureTime = null
      this.actualUnBerthPlanDate = null // 实际离泊时间
      this.actualDepartureTime = null // 实际起飞时间
      this.actualArrivalTime = null // 实际抵达时间
      this.overseaAgentUsersList = []
      this.clearByBusiness = false
      this.hasUpdate = false
      this.localService = {
        checkState: false,
        clearCheck: false
      }
      this.destinationPortService = {
        checkState: false,
        clearCheck: false
      }
      this.userDefinedField1 = '' // 自定义字段1
      this.userDefinedField2 = '' // 自定义字段2
      this.userDefinedField3 = '' // 自定义字段3
      this.userDefinedField4 = '' // 自定义字段4
      this.warehouseCmp = 0 // 仓库名称
      this.warehouseName = '' // 仓库名称
      this.mblNo = '' // 主单号
      this.carrierId = 0 // 航空公司
      this.voyageFlight = '' // 航班
      this.estimatedDeliveryTime = null // 预计出库时间
      this.etd = null // 开航日期
      this.eta = null // 到港日期
      this.destinationAgent = 0 // 目的港代理
      this.carryingCmp = 0 // 运输公司
      this.remarks = '' // 备注
      this.bookingAgent = 0 // 订舱代理
      this.icCarrierCompanyValue = '' // 国际卡航运输公司
      this.icBookingAgentValue = '' // 国际卡航订舱代理
      this.icWarehouseSupplierValue = '' // 国际卡航仓库供应商
    },
    initDataCategoris() {
      const canBatchUpdateBusinessPeople = this.$checkPermission(['button_SEBooking_BatchUpdateBusinessPeople'])
      const canBatchUpdateCategoryOfGoods = this.$checkPermission(['button_SEBooking_BatchUpdateCategoryOfGoods'])
      const canBatchUpdateContainerAndSealNo = this.$checkPermission(['button_SEBooking_BatchUpdateContainerAndSealNo'])
      const canBatchUpdateServiceItem = this.$checkPermission(['button_SEBooking_BatchUpdateServiceItem'])
      // 业务人员
      const businessPeopleChildren = [
        {
          value: 'BUSINESS_OP_TYPE',
          label: this.$t('SeaExport.Operation')
        }, {
          value: 'BUSINESS_SALES_TYPE',
          label: this.$t('SeaExport.Sales')
        }, {
          value: 'BUSINESS_CSR_TYPE',
          label: this.$t('SeaExport.CustomerService')
        }, {
          value: 'BUSINESS_DC_TYPE',
          label: this.$t('SeaExport.Documents')
        }, {
          value: 'BUSINESS_OVERSEA_OP_TYPE',
          label: this.$t('SeaExport.OverseaCustomerService')
        }, {
          value: 'BUSINESS_CARGO_SALES_TYPE',
          label: this.$t('SeaExport.SalesOfGoods')
        }, {
          value: 'BUSINESS_PLANNER_TYPE',
          label: this.$t('SeaExport.AirlinePerson2')
        }, {
          value: 'BUSINESS_UDR1_TYPE',
          label: this.uiCustomElementMap.has('userDefinedRoleId1') && this.uiCustomElementMap.get('userDefinedRoleId1').customLabel
            ? this.uiCustomElementMap.get('userDefinedRoleId1').customLabel : this.$t('SeaExport.UserDefinedRole1')
        }, {
          value: 'BUSINESS_UDR2_TYPE',
          label: this.uiCustomElementMap.has('userDefinedRoleId2') && this.uiCustomElementMap.get('userDefinedRoleId2').customLabel
            ? this.uiCustomElementMap.get('userDefinedRoleId2').customLabel : this.$t('SeaExport.UserDefinedRole2')
        }, {
          value: 'BUSINESS_UDR3_TYPE',
          label: this.uiCustomElementMap.has('userDefinedRoleId3') && this.uiCustomElementMap.get('userDefinedRoleId3').customLabel
            ? this.uiCustomElementMap.get('userDefinedRoleId3').customLabel : this.$t('CargoMsg.Cargo_userDefinedRole3')
        }, {
          value: 'BUSINESS_UDR4_TYPE',
          label: this.uiCustomElementMap.has('userDefinedRoleId4') && this.uiCustomElementMap.get('userDefinedRoleId4').customLabel
            ? this.uiCustomElementMap.get('userDefinedRoleId4').customLabel : this.$t('CargoMsg.Cargo_userDefinedRole4')
        }, {
          value: 'BUSINESS_UDR5_TYPE',
          label: this.uiCustomElementMap.has('userDefinedRoleId5') && this.uiCustomElementMap.get('userDefinedRoleId5').customLabel
            ? this.uiCustomElementMap.get('userDefinedRoleId5').customLabel : this.$t('CargoMsg.Cargo_userDefinedRole5')
        }, {
          value: 'BUSINESS_UDR6_TYPE',
          label: this.uiCustomElementMap.has('userDefinedRoleId6') && this.uiCustomElementMap.get('userDefinedRoleId6').customLabel
            ? this.uiCustomElementMap.get('userDefinedRoleId6').customLabel : this.$t('CargoMsg.Cargo_userDefinedRole6')
        }, {
          value: 'BUSINESS_UDR7_TYPE',
          label: this.uiCustomElementMap.has('userDefinedRoleId7') && this.uiCustomElementMap.get('userDefinedRoleId7').customLabel
            ? this.uiCustomElementMap.get('userDefinedRoleId7').customLabel : this.$t('CargoMsg.Cargo_userDefinedRole7')
        }
      ]
      const businessPeople = {
        value: 'BUSINESS_PEOPLE_TYPE',
        label: this.$t('SeaExport.BusinessPeopleType'),
        children: businessPeopleChildren
      }
      const categoryOfGoods = {
        value: 'CATEGORY_OF_GOODS_TYPE',
        label: this.$t('SeaExport.CategoryOfGoods')
      }
      const updateEtaDate = {
        value: 'ETA_DATE_TYPE',
        label: this.lob === 'SE' ? this.$t('CargoMsg.Cargo_SETitle') : this.$t('CargoMsg.Cargo_AETitle')
      }
      const updateCurEtaDate = {
        value: 'CUR_ETA_DATE_TYPE',
        label: this.$t('CargoMsg.Cargo_CurentSETitle')
      }
      const eqSize = {
        value: 'EQ_SIZE_TYPE',
        label: this.$t('SeaExport.BoxType')
      }
      const containerAndSealNo = {
        value: 'CONTAINER_AND_SEAL_NO_TYPE',
        label: this.$t('SeaExport.ContainerNo') + this.$t('SeaExport.SealNo')
      }
      const updateAtdAtaDate = {
        value: 'ATD_ATA_DATE_TYPE',
        label: this.lob === 'SE' ? this.$t('CargoMsg.Cargo_SEAtdAtaTitle') : this.$t('CargoMsg.Cargo_AEAtdAtaTitle')
      }
      const updateOriginalEtaDate = {
        value: 'ORIGINAL_ETA_DATE_TYPE',
        label: this.$t('CargoMsg.Cargo_OriginalSETitle')
      }
      const userDefinedField1 = {
        value: 'USER_DEFINED_FIELD1',
        label: this.$t('SeaExport.UserDefinedField1')
      }
      const userDefinedField2 = {
        value: 'USER_DEFINED_FIELD2',
        label: this.$t('SeaExport.UserDefinedField2')
      }
      const userDefinedField3 = {
        value: 'USER_DEFINED_FIELD3',
        label: this.$t('SeaExport.UserDefinedField3')
      }
      const userDefinedField4 = {
        value: 'USER_DEFINED_FIELD4',
        label: this.$t('SeaExport.UserDefinedField4')
      }
      const warehouseCmp = {
        value: 'WAREHOUSE_CMP',
        label: this.isOpenWarehouse ? this.$t('SeaExport.WarehouseSupplier') + '/' + this.$t('SeaExport.WareHouseName') : this.$t('CargoMsg.Cargo_Warehouse')
      }
      const mblNo = {
        value: 'MBL_NO',
        label: this.$t('SeaExport.Mbl2')
      }
      const airlineCompany = {
        value: 'CARRIER_ID',
        label: this.$t('SeaExport.AirlineCompany')
      }
      const voyageFlight = {
        value: 'VOYAGE_FLIGHT',
        label: this.$t('SeaExport.Flight')
      }
      const estimatedDeliveryTime = {
        value: 'ESTIMATED_DELIVERY_TIME',
        label: this.$t('CargoMsg.Cargo_EstimatedDeliveryTime')
      }
      const etd = {
        value: 'ETD',
        label: this.$t('SeaExport.DateOfDeparture')
      }
      const eta = {
        value: 'ETA',
        label: this.$t('SeaExport.DateOfArrival')
      }
      const remarks = {
        value: 'REMARKS',
        label: this.uiCustomElementMap.has('remarks') && this.uiCustomElementMap.get('remarks').customLabel ? this.uiCustomElementMap.get('remarks').customLabel : this.$t('SeaExport.BasicRemarks')
      }
      const bookingAgent = {
        value: 'BOOKING_AGENT',
        label: this.$t('SeaExport.BookingAgent')
      }
      const destinationAgent = {
        value: 'DESTINATION_AGENT',
        label: this.$t('SeaExport.DestinationAgent')
      }
      const carryingCmp = {
        value: 'TRUCKING_CMP',
        label: this.$t('SeaExport.HaulageCompany')
      }
      if (this.lob === 'SE') {
        if (this.$checkPermission(['button_SEBooking_BatchUpdateEqSize'])) {
          this.dataCategoris.push(eqSize)
        }
        if (canBatchUpdateContainerAndSealNo) {
          this.dataCategoris.push(containerAndSealNo)
        }
        if (canBatchUpdateCategoryOfGoods) {
          this.dataCategoris.push(categoryOfGoods)
        }
        // 计划离泊时间/预计到港时间
        if (this.$checkPermission(['button_SEBooking_BatchUpdateEtdDate'])) {
          if (this.isXycw) {
            this.dataCategoris.push(updateCurEtaDate)
          } else {
            this.dataCategoris.push(updateEtaDate)
          }
        }
        // 实际离泊时间(ATD)/实际到港时间(ATA)
        if (this.$checkPermission(['button_SEBooking_BatchUpdateEtdDate'])) {
          this.dataCategoris.push(updateAtdAtaDate)
        }

        if (this.$checkPermission(['button_SEBooking_BatchUpdateEtdDate']) && this.isXycw) {
          this.dataCategoris.push(updateOriginalEtaDate)
        }
        // 目的港代理
        if (this.$checkPermission(['button_SEBooking_BatchUpdateDestinationAgent'])) {
          this.dataCategoris.push(destinationAgent)
        }
        // 运输公司
        this.dataCategoris.push(carryingCmp)
        if (canBatchUpdateBusinessPeople) {
          businessPeopleChildren.push(...[
            {
              value: 'BUSINESS_PRE_PORT_PLANNER_TYPE',
              label: this.$t('CargoMsg.Cargo_PrePortBusinessLeader')
            },
            {
              value: 'BUSINESS_LAST_MILE_PLANNER_TYPE',
              label: this.$t('CargoMsg.Cargo_LastMileBusinessLeader')
            }
          ])
          this.dataCategoris.push(businessPeople)
        }
        if (canBatchUpdateServiceItem) {
          this.dataCategoris.push({
            value: 'LOCAL_SERVICE',
            label: this.$t('SeaExport.LocalService'),
            children: [
              {
                value: 'WAREHOUSING',
                label: this.$t('SeaExport.WarehouseLoadingStorage')
              }, {
                value: 'LAND_TRANSPORTATION',
                label: this.$t('SeaExport.DoorLoadingDelivery')
              }, {
                value: 'SELF_DELIVER',
                label: this.$t('SeaExport.NotResponsibleForTruckingAndLoading')
              }, {
                value: 'BACK_UP_WAREHOUSE',
                label: this.$t('SeaExport.BackUpWarehouse')
              }, {
                value: 'CUSTOMS',
                label: this.$t('SeaExport.CustomsDeclaration')
              }, {
                value: 'Booking',
                label: this.$t('SeaExport.Booking')
              }
            ]
          }, {
            value: 'DESTINATION_PORT_SERVICE',
            label: this.$t('SeaExport.PortOfDestinationServices'),
            children: [
              {
                value: 'DISCHARGING_PORT_DOOR',
                label: this.$t('SeaExport.DispatchVehiclesAtDestination')
              }, {
                value: 'US_CUSTOMS_CLEARANCE',
                label: this.$t('queryJob.UsCustomsClearance')
              }
            ]
          })
        }
        // 备注
        this.dataCategoris.push(remarks)
      }
      if (this.lob === 'SI') {
        if (this.$checkPermission(['button_SIBOOKING_BatchUpdateEqSize'])) {
          this.dataCategoris.push(eqSize)
        }
        if (this.$checkPermission(['button_SIBOOKING_BatchUpdateContainerAndSealNo'])) {
          this.dataCategoris.push(containerAndSealNo)
        }
        if (this.$checkPermission(['button_SIBOOKING_BatchUpdateCategoryOfGoods'])) {
          this.dataCategoris.push(categoryOfGoods)
        }
        if (this.$checkPermission(['button_SIBOOKING_BatchUpdateBusinessPeople'])) {
          this.dataCategoris.push(businessPeople)
        }
        // 备注
        this.dataCategoris.push(remarks)
      }
      if (this.lob === 'AE') {
        if (this.$checkPermission(['button_AEBooking_BatchUpdateCategoryOfGoods'])) {
          this.dataCategoris.push(categoryOfGoods)
        }
        // 预计起飞时间/预计抵达时间
        if (this.$checkPermission(['button_AEBooking_BatchUpdateEtdDate'])) {
          this.dataCategoris.push(updateEtaDate)
        }
        if (this.$checkPermission(['button_AEBooking_BatchUpdateBusinessPeople'])) {
          this.dataCategoris.push(businessPeople)
        }
        // 实际起飞时间(ATD)/实际抵达时间(ATA)
        if (this.$checkPermission(['button_AEBooking_BatchUpdateEtdDate'])) {
          this.dataCategoris.push(updateAtdAtaDate)
        }
        // 自定义字段
        this.dataCategoris.push(userDefinedField1)
        this.dataCategoris.push(userDefinedField2)
        this.dataCategoris.push(userDefinedField3)
        this.dataCategoris.push(userDefinedField4)
        // 仓库名称
        this.dataCategoris.push(warehouseCmp)
        // 主单号
        this.dataCategoris.push(mblNo)
        // 航空公司
        this.dataCategoris.push(airlineCompany)
        // 航班
        this.dataCategoris.push(voyageFlight)
        // 预计出库时间
        this.dataCategoris.push(estimatedDeliveryTime)
        // 开航日期
        this.dataCategoris.push(etd)
        // 到港日期
        this.dataCategoris.push(eta)
        // 预计出库时间
        this.dataCategoris.push(remarks)
        // 订舱代理
        this.dataCategoris.push(bookingAgent)
      }
      if (this.lob === 'AI') {
        if (this.$checkPermission(['button_AIBooking_BatchUpdateCategoryOfGoods'])) {
          this.dataCategoris.push(categoryOfGoods)
        }
        if (this.$checkPermission(['button_AIBooking_BatchUpdateBusinessPeople'])) {
          this.dataCategoris.push(businessPeople)
        }
        // 备注
        this.dataCategoris.push(remarks)
      }
      if (this.lob === 'RE' || this.lob === 'RI') {
        if (this.$checkPermission(['button_REBooking_BatchUpdateEqSize'])) {
          this.dataCategoris.push(eqSize)
        }
        if (this.$checkPermission(['button_REBooking_BatchUpdateCategoryOfGoods'])) {
          this.dataCategoris.push(categoryOfGoods)
        }
        if (this.$checkPermission(['button_REBooking_BatchUpdateBusinessPeople'])) {
          this.dataCategoris.push(businessPeople)
        }
        // 备注
        this.dataCategoris.push(remarks)
      }
      if (this.lob === 'IE') {
        if (!this.integratedLogisticsType) {
          if (this.$checkPermission(['button_IEBooking_BatchUpdateCategoryOfGoods'])) {
            this.dataCategoris.push(categoryOfGoods)
          }
          if (this.$checkPermission(['button_IEBooking_BatchUpdateBusinessPeople'])) {
            this.dataCategoris.push(businessPeople)
          }
        } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_TT.code) {
          if (this.$checkPermission(['button_TTIEBooking_BatchUpdateCategoryOfGoods'])) {
            this.dataCategoris.push(categoryOfGoods)
          }
          if (this.$checkPermission(['button_TTIEBooking_BatchUpdateBusinessPeople'])) {
            this.dataCategoris.push(businessPeople)
          }
        } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_IC.code) {
          if (this.$checkPermission(['button_ICIEBooking_BatchUpdateCategoryOfGoods'])) {
            this.dataCategoris.push(categoryOfGoods)
          }
          if (this.$checkPermission(['button_ICIEBooking_BatchUpdateBusinessPeople'])) {
            this.dataCategoris.push(businessPeople)
          }
        } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_CL.code) {
          if (this.$checkPermission(['button_CLIEBooking_BatchUpdateCategoryOfGoods'])) {
            this.dataCategoris.push(categoryOfGoods)
          }
          if (this.$checkPermission(['button_CLIEBooking_BatchUpdateBusinessPeople'])) {
            this.dataCategoris.push(businessPeople)
          }
        }
        // 备注
        this.dataCategoris.push(remarks)
        if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_IC.code) {
          const icCarrierCompany = {
            value: 'IC_CARRIER_COMPANY',
            label: '运输公司'
          }
          const icBookingAgent = {
            value: 'IC_BOOKING_AGENT',
            label: this.$t('SeaExport.BookingAgent')
          }
          const icWarehouseSupplier = {
            value: 'IC_WAREHOUSE_SUPPLIER',
            label: this.$t('SeaExport.WarehouseSupplier')
          }
          this.dataCategoris.push(icCarrierCompany)
          this.dataCategoris.push(icBookingAgent)
          this.dataCategoris.push(icWarehouseSupplier)
        }
      }
      if (this.dataCategoris.length > 0) {
        if (this.dataCategoris[0].value === 'BUSINESS_PEOPLE_TYPE') {
          if (!this.job) {
            for (const job of this.jobList) {
              if (job.opOffice === job.salesOffice) {
                this.job = job
                this.officeId = job.opOffice
                break
              }
            }
          }
          const arr = []
          arr.push(this.dataCategoris[0].value)
          arr.push(businessPeopleChildren[0].value)
          this.dataCategory = arr
          this.dataCategoryValue = businessPeopleChildren[0].value
        } else {
          this.dataCategoryValue = this.dataCategoris[0].value
          this.dataCategory = this.dataCategoris[0].value
        }
      }
    },
    async getOverseaAgentUserByConfig() {
      this.overseaAgentUsersList = await User.getUsersByPrivilegeDetail('role', 'overseaOp', '', this.officeId, true)
    },
    onDataCategoryChange(categoryList) {
      this.userId = ''
      this.depId = ''
      this.cargoCode = ''
      this.cargoName = ''
      this.containerNo = ''
      this.sealNo = ''
      this.unBerthPlanDate = null
      this.estimatedArrivalTime = null
      this.estimatedDepartureTime = null
      this.actualUnBerthPlanDate = null // 实际离泊时间
      this.actualDepartureTime = null // 实际起飞时间
      this.actualArrivalTime = null // 实际抵达时间
      this.userDefinedField1 = '' // 自定义字段1
      this.userDefinedField2 = '' // 自定义字段2
      this.userDefinedField3 = '' // 自定义字段3
      this.userDefinedField4 = '' // 自定义字段4
      this.warehouseCmp = 0 // 仓库名称
      this.warehouseName = '' // 仓库名称
      this.mblNo = '' // 主单号
      this.carrierId = 0 // 航空公司
      this.voyageFlight = '' // 航班
      this.estimatedDeliveryTime = null // 预计出库时间
      this.etd = null // 开航日期
      this.eta = null // 到港日期
      this.remarks = '' // 备注
      this.bookingAgent = 0 // 订舱代理
      this.icCarrierCompanyValue = '' // 国际卡航运输公司
      this.icBookingAgentValue = '' // 国际卡航订舱代理
      this.icWarehouseSupplierValue = '' // 国际卡航仓库供应商
      this.carryingCmp = 0 // 运输公司
      this.clearByBusiness = false
      this.localService.checkState = false
      this.localService.clearCheck = false
      this.destinationPortService.checkState = false
      this.destinationPortService.clearCheck = false
      if (categoryList) {
        this.dataCategoryValue = categoryList[categoryList.length - 1]
      }
      if (this.isBusinessPeople) {
        if (this.job) {
          return
        }
        for (const job of this.jobList) {
          if (job.opOffice === job.salesOffice) {
            this.job = job
            this.officeId = job.opOffice
            break
          }
        }
        if (!this.job) {
          this.dataCategoryValue = ''
          this.$alert(this.$t('CargoMsg.Cargo_invalidBatchModifyBusiness'), this.$t('Message.Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
            type: 'warning'
          })
        }
      }
    },
    businessPeopleChangeHandler(user, shape) {
      const job = this.job
      if (user.defaultDepId > 0) {
        this.depId = user.defaultDepId
      } else {
        if (job.opOffice > 0) {
          new User(user).getUserDefaultDepartmentByOffice('role', shape, job.opOffice).then(dep => {
            this.depId = dep ? dep.departmentId : 0
          })
        } else {
          new User(user).getDefaultDepartment('role', shape, job.opOffice).then(dep => {
            this.depId = dep ? dep.departmentId : 0
          })
        }
      }
    },
    onClearByBusinessChange() {
      if (this.clearByBusiness) {
        if (this.isBusinessPeople) {
          this.userId = ''
          this.depId = ''
        } else if (this.dataCategoryValue === 'CATEGORY_OF_GOODS_TYPE') {
          this.cargoCode = ''
          this.cargoName = ''
        } else if (this.dataCategoryValue === 'CONTAINER_AND_SEAL_NO_TYPE') {
          this.containerNo = ''
          this.sealNo = ''
        } else if (this.dataCategoryValue === 'DESTINATION_AGENT') {
          this.destinationAgent = 0
        } else if (this.dataCategoryValue === 'IC_CARRIER_COMPANY') {
          this.icCarrierCompanyValue = ''
        } else if (this.dataCategoryValue === 'IC_BOOKING_AGENT') {
          this.icBookingAgentValue = ''
        } else if (this.dataCategoryValue === 'IC_WAREHOUSE_SUPPLIER') {
          this.icWarehouseSupplierValue = ''
        }
      }
    },
    async cargoCodeChange(data) {
      this.cargoCode = data
      if (data === null || data === '') {
        this.cargoCode = data
        this.cargoName = ''
      } else {
        const cargoInformation = getObjectByCache(basicCacheKeys.basic_data_CargoInformation, 'code', data)
        if (cargoInformation) {
          this.cargoCode = cargoInformation.code
          this.cargoName = cargoInformation.englishName
        }
      }
    },
    async businessConfirmHandler() {
      const item = this.dataCategoris.find(p => p.value === 'BUSINESS_PEOPLE_TYPE').children.find(p => p.value === this.dataCategoryValue)
      if (this.clearByBusiness) {
        const flag = await this.$confirm(this.dataCategoryValue === 'BUSINESS_CARGO_SALES_TYPE' ? this.$t('SeaExport.clearCategoryConfirm', [item.label]) : this.$t('SeaExport.clearConfirm', [item.label, item.label + this.$t('SeaExport.Department')]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.confirm'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      } else {
        if (!this.userId && !this.depId) {
          this.$message.warning(this.$t('SeaExport.hasOneAtleast'))
          return
        } else if ((!this.userId || !this.depId) && ['BUSINESS_OP_TYPE', 'BUSINESS_SALES_TYPE', 'BUSINESS_CARGO_SALES_TYPE', 'BUSINESS_UDR1_TYPE', 'BUSINESS_UDR2_TYPE',
          'BUSINESS_UDR3_TYPE', 'BUSINESS_UDR4_TYPE', 'BUSINESS_UDR5_TYPE', 'BUSINESS_UDR6_TYPE', 'BUSINESS_UDR7_TYPE', 'BUSINESS_PRE_PORT_PLANNER_TYPE', 'BUSINESS_LAST_MILE_PLANNER_TYPE'].indexOf(this.dataCategoryValue) === -1) {
          this.$message.warning(this.$t('SeaExport.requireAllSelect', [item.label, item.label + this.$t('SeaExport.Department')]))
          return
        }
        let confirmTitle = ''
        if (this.userId && this.depId && ['BUSINESS_UDR1_TYPE', 'BUSINESS_UDR2_TYPE',
          'BUSINESS_UDR3_TYPE', 'BUSINESS_UDR4_TYPE', 'BUSINESS_UDR5_TYPE', 'BUSINESS_UDR6_TYPE', 'BUSINESS_UDR7_TYPE', 'BUSINESS_PRE_PORT_PLANNER_TYPE', 'BUSINESS_LAST_MILE_PLANNER_TYPE'].indexOf(this.dataCategoryValue) === -1) {
          confirmTitle = this.$t('SeaExport.changeTwoConfirm', [item.label, item.label + this.$t('SeaExport.Department')])
        } else if (this.userId) {
          confirmTitle = this.$t('SeaExport.changeOneConfirm', [item.label])
        } else {
          confirmTitle = this.$t('SeaExport.changeOneConfirm', [item.label + this.$t('SeaExport.Department')])
        }
        const flag = await this.$confirm(confirmTitle, this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.confirm'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }
      const loading = getLoading4Cxt(this)
      try {
        const params = { lob: this.lob, clearByBusiness: this.clearByBusiness, businessPeopleType: this.dataCategoryValue, jobKeys: this.jobKeys, userId: Number(this.userId), depId: Number(this.depId), officeId: this.officeId }
        const res = await batchUpdateBusinessPeopleType(params)
        const { successJobNoList, notOperateJobNoList, blockJobNoList, notSameOpAndSalesOfficeJobNoList } = res.data
        if (successJobNoList.length > 0) {
          this.hasUpdate = true
        }
        if (successJobNoList.length === this.jobKeys.length) {
          this.$message.success(this.$t(this.clearByBusiness ? 'SeaExport.SuccessfullyClearXPieces' : 'SeaExport.SuccessfullyReplacedXPieces', [successJobNoList.length, this.$t('SeaExport.BusinessPeopleType')]))
          this.innerVisible = false
        } else {
          const failCount = notOperateJobNoList.length + blockJobNoList.length + notSameOpAndSalesOfficeJobNoList.length
          let msg = this.$t(this.clearByBusiness ? 'SeaExport.PartSuccessClearXPieces' : 'SeaExport.PartSuccessReplacedXPieces', [successJobNoList.length, this.$t('SeaExport.BusinessPeopleType'), failCount])
          if (notOperateJobNoList.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisNotPositiveOperation', [notOperateJobNoList.join(',')])
          }
          if (notSameOpAndSalesOfficeJobNoList.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessNotSameOpAndSalesOffice', [notSameOpAndSalesOfficeJobNoList.join(',')])
          }
          if (blockJobNoList.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisBlocked', [blockJobNoList.join(',')])
          }
          this.failDialog.content = msg
          this.failDialog.jobNos = [...notOperateJobNoList, ...notSameOpAndSalesOfficeJobNoList, ...blockJobNoList].join(',')
          this.failDialog.visible = true
        }
      } finally {
        loading.close()
      }
    },
    async updateDateConfirmHandler() {
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      const flag = await this.$confirm(this.$t('SeaExport.changeOneConfirm', [item.label]), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }
      if (this.lob === 'SE' && !this.unBerthPlanDate && !this.estimatedArrivalTime) {
        this.$message.warning(this.$t('CargoMsg.Cargo_UpdateDateTip'))
        return
      }

      if (this.lob === 'AE' && !this.estimatedDepartureTime && !this.estimatedArrivalTime) {
        this.$message.warning(this.$t('CargoMsg.Cargo_UpdateDateTip2'))
        return
      }

      const loading = getLoading4Cxt(this)
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        keys: this.jobKeys,
        lob: this.lob,
        anyDate: this.lob === 'SE' ? this.unBerthPlanDate : this.estimatedDepartureTime,
        anyDate1: this.estimatedArrivalTime
      }
      await batchUpdateDateFunc(params).then(res => {
        const { successJobNos, jobStateJobNos } = res.data
        if (jobStateJobNos.length > 0) {
          const jobNos = jobStateJobNos.join(',')
          this.$message.warning({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip1', [successJobNos.length, jobStateJobNos.length, jobNos]) })
        } else {
          this.$message.success({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip', [successJobNos.length]) })
        }
        this.innerVisible = false
      }).catch().finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    async updateCurDateHandler() {
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      const flag = await this.$confirm(this.$t('SeaExport.changeOneConfirm', [item.label]), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }
      if (!this.currentETD && !this.currentArrivalETA) {
        this.$message.warning(this.$t('CargoMsg.Cargo_UpdateDateTip'))
        return
      }

      const loading = getLoading4Cxt(this)
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        keys: this.jobKeys,
        lob: this.lob,
        anyDate: this.currentETD,
        anyDate1: this.currentArrivalETA
      }
      await batchUpdateCurDateFunc(params).then(res => {
        const { successJobNos, jobStateJobNos } = res.data
        if (jobStateJobNos.length > 0) {
          const jobNos = jobStateJobNos.join(',')
          this.$message.warning({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip1', [successJobNos.length, jobStateJobNos.length, jobNos]) })
        } else {
          this.$message.success({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip', [successJobNos.length]) })
        }
        this.innerVisible = false
      }).catch().finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    async updateOriginalDateHandler() {
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      const flag = await this.$confirm(this.$t('SeaExport.changeOneConfirm', [item.label]), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }
      if (!this.unBerthPlanDate && !this.estimatedArrivalTime) {
        this.$message.warning(this.$t('CargoMsg.Cargo_UpdateDateTip'))
        return
      }

      const loading = getLoading4Cxt(this)
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        keys: this.jobKeys,
        lob: this.lob,
        anyDate: this.unBerthPlanDate,
        anyDate1: this.estimatedArrivalTime
      }
      await batchUpdateOriginalDateFunc(params).then(res => {
        const { successJobNos, jobStateJobNos } = res.data
        if (jobStateJobNos.length > 0) {
          const jobNos = jobStateJobNos.join(',')
          this.$message.warning({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip1', [successJobNos.length, jobStateJobNos.length, jobNos]) })
        } else {
          this.$message.success({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip', [successJobNos.length]) })
        }
        this.innerVisible = false
      }).catch().finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    async updateAtdAtaDateConfirmHandler() {
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      const flag = await this.$confirm(this.$t('SeaExport.changeOneConfirm', [item.label]), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }
      if (this.lob === 'SE' && !this.actualUnBerthPlanDate && !this.actualArrivalTime) {
        this.$message.warning(this.$t('CargoMsg.Cargo_UpdateAtdAtaDateTip'))
        return
      }

      if (this.lob === 'AE' && !this.actualDepartureTime && !this.actualArrivalTime) {
        this.$message.warning(this.$t('CargoMsg.Cargo_UpdateAtdAtaDateTip2'))
        return
      }

      const loading = getLoading4Cxt(this)
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        keys: this.jobKeys,
        lob: this.lob,
        anyDate: this.lob === 'SE' ? this.actualUnBerthPlanDate : this.actualDepartureTime,
        anyDate1: this.actualArrivalTime
      }
      await batchUpdateAtdAtaDateFunc(params).then(res => {
        const { successJobNos, jobStateJobNos } = res.data
        if (jobStateJobNos.length > 0) {
          const jobNos = jobStateJobNos.join(',')
          this.$message.warning({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip1', [successJobNos.length, jobStateJobNos.length, jobNos]) })
        } else {
          this.$message.success({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip', [successJobNos.length]) })
        }
        this.innerVisible = false
      }).catch().finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    async categoryConfirmHandler() {
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      if (this.clearByBusiness) {
        const flag = await this.$confirm(this.$t('SeaExport.clearCategoryConfirm', [item.label]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.confirm'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      } else {
        if (!this.cargoCode) {
          this.$message.warning(this.$t('SeaExport.hasOneCategoryAtleast'))
          return
        }
        const flag = await this.$confirm(this.$t('SeaExport.changeOneConfirm', [item.label]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.confirm'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }
      const loading = getLoading4Cxt(this)
      try {
        const params = { clearByBusiness: this.clearByBusiness, jobKeys: this.jobKeys, cargoCode: this.cargoCode, cargoName: this.cargoName }
        const res = await batchUpdateCategoryOfGoodsType(params)
        const { successJobNoList, blockJobNoList, notOperateJobNoList } = res.data
        if (successJobNoList.length > 0) {
          this.hasUpdate = true
        }
        if (successJobNoList.length === this.jobKeys.length) {
          this.$message.success(this.$t(this.clearByBusiness ? 'SeaExport.SuccessfullyClearXPieces' : 'SeaExport.SuccessfullyReplacedXPieces', [successJobNoList.length, item.label]))
          this.innerVisible = false
        } else {
          const failCount = blockJobNoList.length + notOperateJobNoList.length
          let msg = this.$t(this.clearByBusiness ? 'SeaExport.PartSuccessClearXPieces' : 'SeaExport.PartSuccessReplacedXPieces', [successJobNoList.length, item.label, failCount])
          if (notOperateJobNoList.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisNotPositiveOperation', [notOperateJobNoList.join(',')])
          }
          if (blockJobNoList.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisBlocked', [blockJobNoList.join(',')])
          }
          this.failDialog.content = msg
          this.failDialog.jobNos = [...notOperateJobNoList, ...blockJobNoList].join(',')
          this.failDialog.visible = true
        }
      } finally {
        loading.close()
      }
    },
    async icDataTypeConfirmHandler(dataType) {
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      let dataValue = ''
      if (dataType === 'CARRIER_COMPANY') {
        dataValue = this.icCarrierCompanyValue
      } else if (dataType === 'BOOKING_AGENT') {
        dataValue = this.icBookingAgentValue
      } else if (dataType === 'WAREHOUSE_SUPPLIER') {
        dataValue = this.icWarehouseSupplierValue
      }
      if (this.clearByBusiness) {
        const flag = await this.$confirm(this.$t('SeaExport.clearCategoryConfirm', [item.label]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.confirm'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      } else {
        if (!dataValue) {
          this.$message.warning(this.$t('SeaExport.hasOneCategoryAtleast'))
          return
        }
        const flag = await this.$confirm(this.$t('SeaExport.changeOneConfirm', [item.label]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.confirm'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }
      const loading = getLoading4Cxt(this)
      try {
        const params = {
          clearByBusiness: this.clearByBusiness,
          jobKeys: this.jobKeys,
          dataType: dataType,
          dataValue: dataValue
        }
        const res = await batchUpdateDataType(params)
        const { successJobNoList, blockJobNoList, notOperateJobNoList } = res.data
        if (successJobNoList.length > 0) {
          this.hasUpdate = true
        }
        if (successJobNoList.length === this.jobKeys.length) {
          this.$message.success(this.$t(this.clearByBusiness ? 'SeaExport.SuccessfullyClearXPieces' : 'SeaExport.SuccessfullyReplacedXPieces', [successJobNoList.length, item.label]))
          this.innerVisible = false
        } else {
          const failCount = blockJobNoList.length + notOperateJobNoList.length
          let msg = this.$t(this.clearByBusiness ? 'SeaExport.PartSuccessClearXPieces' : 'SeaExport.PartSuccessReplacedXPieces', [successJobNoList.length, item.label, failCount])
          if (notOperateJobNoList.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisNotPositiveOperation', [notOperateJobNoList.join(',')])
          }
          if (blockJobNoList.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisBlocked', [blockJobNoList.join(',')])
          }
          this.failDialog.content = msg
          this.failDialog.jobNos = [...notOperateJobNoList, ...blockJobNoList].join(',')
          this.failDialog.visible = true
        }
      } finally {
        loading.close()
      }
    },
    async containerConfirmHandler() {
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      if (this.clearByBusiness) {
        const flag = await this.$confirm(this.$t('SeaExport.clearCategoryConfirm', [item.label]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.confirm'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      } else {
        if (!this.containerNo && !this.sealNo) {
          this.$message.warning(this.$t('SeaExport.hasOneNoAtleast'))
          return
        }
        const flag = await this.$confirm(this.$t('SeaExport.changeOneConfirm', [item.label]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.confirm'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }
      const loading = getLoading4Cxt(this)
      try {
        const params = { clearByBusiness: this.clearByBusiness, jobKeys: this.jobKeys, containerNo: this.containerNo, sealNo: this.sealNo, lob: this.lob }
        const res = await batchUpdateContainerAndSealNo(params)
        const { successJobNoList, blockJobNoList, hblLockJobNoList, notOperateJobNoList, invaildLoadTypeJobNoList } = res.data
        const failCount = blockJobNoList.length + notOperateJobNoList.length + hblLockJobNoList.length + invaildLoadTypeJobNoList.length
        if (successJobNoList.length > 0) {
          this.hasUpdate = true
        }
        if (successJobNoList.length === this.jobKeys.length || failCount === 0) {
          this.$message.success(this.$t(this.clearByBusiness ? 'SeaExport.SuccessfullyClearXPieces' : 'SeaExport.SuccessfullyReplacedXPieces', [successJobNoList.length, item.label]))
          this.innerVisible = false
        } else {
          let msg = this.$t(this.clearByBusiness ? 'SeaExport.PartSuccessClearXPieces' : 'SeaExport.PartSuccessReplacedXPieces', [successJobNoList.length, item.label, failCount])
          if (notOperateJobNoList.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisNotPositiveOperation', [notOperateJobNoList.join(',')])
          }
          if (blockJobNoList.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisBlocked', [blockJobNoList.join(',')])
          }
          if (hblLockJobNoList.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisHblLock', [hblLockJobNoList.join(',')])
          }
          if (invaildLoadTypeJobNoList.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisInvalidLoadType', [invaildLoadTypeJobNoList.join(',')])
          }
          this.failDialog.content = msg
          this.failDialog.jobNos = [...blockJobNoList, ...hblLockJobNoList, ...notOperateJobNoList, ...invaildLoadTypeJobNoList].join(',')
          this.failDialog.visible = true
        }
      } finally {
        loading.close()
      }
    },
    async confirmHandler() {
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      if (this.newEqSize === this.originEqSize && this.newEqType === this.originEqType) {
        this.$message.warning(this.$t('SeaExport.DataAdjustmentSame', [item.label]))
        return
      }
      const flag = await this.$confirm(this.$t('SeaExport.DataAdjustmentAgainConfirm', [item.label]), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }
      const loading = getLoading4Cxt(this)
      try {
        const res = await batchUpdateEqSizeType(this.jobKeys, this.originEqSize, this.originEqType, this.newEqSize, this.newEqType, this.lob)
        const {
          successJobNos, notMatchJobNos, notOperateJobNos, blockJobNos, hblLockJobNos, mblHblContainerJobNos,
          containerSealNoJobNos, truckingJobNos, dischargingTruckingJobNos, amsContainerJobNos, eqSizeTypeExistJobNos
        } = res.data
        if (successJobNos.length > 0) {
          this.hasUpdate = true
        }
        if (successJobNos.length === this.jobKeys.length) {
          this.$message.success(this.$t('SeaExport.SuccessfullyReplacedXPieces', [successJobNos.length, item.label]))
          this.innerVisible = false
        } else if (notMatchJobNos.length === this.jobKeys.length) {
          this.$message.warning(this.$t('SeaExport.NotReplacedXPieces', [item.label]))
        } else {
          const failCount = notMatchJobNos.length + notOperateJobNos.length + blockJobNos.length + hblLockJobNos.length + mblHblContainerJobNos.length +
            containerSealNoJobNos.length + truckingJobNos.length + dischargingTruckingJobNos.length + amsContainerJobNos.length + eqSizeTypeExistJobNos.length
          let msg = this.$t('SeaExport.PartSuccessReplacedXPieces', [successJobNos.length, item.label, failCount])
          if (notMatchJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessPicecNotMatch', [notMatchJobNos.join(',')])
          }
          if (notOperateJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisNotPositiveOperation', [notOperateJobNos.join(',')])
          }
          if (blockJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisBlocked', [blockJobNos.join(',')])
          }
          if (hblLockJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisHblLock', [hblLockJobNos.join(',')])
          }
          if (mblHblContainerJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisMblHblContainerExist', [mblHblContainerJobNos.join(',')])
          }
          if (containerSealNoJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisContainerSealNoExist', [containerSealNoJobNos.join(',')])
          }
          if (truckingJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisTruckingContainerExist', [truckingJobNos.join(',')])
          }
          if (dischargingTruckingJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisDischarginTruckingExist', [dischargingTruckingJobNos.join(',')])
          }
          if (amsContainerJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisAmsContainerExist', [amsContainerJobNos.join(',')])
          }
          if (eqSizeTypeExistJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisContainerExist', [eqSizeTypeExistJobNos.join(',')])
          }
          this.failDialog.content = msg
          this.failDialog.jobNos = [
            ...notMatchJobNos, ...notOperateJobNos, ...blockJobNos, ...hblLockJobNos, ...mblHblContainerJobNos,
            ...containerSealNoJobNos, ...truckingJobNos, ...dischargingTruckingJobNos, ...amsContainerJobNos, ...eqSizeTypeExistJobNos
          ].join(',')
          this.failDialog.visible = true
        }
      } finally {
        loading.close()
      }
    },
    copyFailJobNos() {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', this.failDialog.jobNos)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$message.success(this.$t('SeaExport.CopySuccess'))
      }
      document.body.removeChild(input)
    },
    async localServiceConfirmHandler() {
      const { checkState, clearCheck } = this.localService
      if (!checkState && !clearCheck) {
        this.$message.warning((this.$t('SeaExport.SelectAtLeastOneAdjustment')))
        return
      }
      const dataCategoryLabel = this.getDataCategoryLabel()
      if (clearCheck) {
        const flag = await this.$confirm(this.dataCategoryValue !== 'CUSTOMS' ? this.$t('SeaExport.ClearStateComfirm', [dataCategoryLabel]) : this.$t('SeaExport.ClearCustomsBrokerComfirm'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.confirm'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      } else if (checkState) {
        let warning = ''
        if (this.dataCategoryValue !== 'CUSTOMS') {
          warning = this.$t('SeaExport.CheckStateComfirm', [dataCategoryLabel])
        } else if (this.customsBroker) {
          warning = this.$t('SeaExport.CheckCustomsBrokerComfirm')
        } else {
          warning = this.$t('SeaExport.CheckCustomsBrokerComfirm2')
        }
        const flag = await this.$confirm(warning, this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.confirm'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }
      const loading = getLoading4Cxt(this)
      try {
        const res = await batchUpdateLocalService(this.jobKeys, this.dataCategoryValue, !clearCheck, this.customsBroker)
        const { successJobNos, notOperateJobNos, blockJobNos, hblLockJobNos, notMatchJobNos } = res.data
        if (successJobNos.length > 0) {
          this.hasUpdate = true
        }
        if (successJobNos.length === this.jobKeys.length) {
          if (clearCheck) {
            this.$message.success(this.$t('SeaExport.SuccessfullyCancelXPieces', [successJobNos.length]))
          } else {
            this.$message.success(this.$t('SeaExport.SuccessfullyCheckXPieces', [successJobNos.length]))
          }
          this.innerVisible = false
        } else if (notMatchJobNos.length > 0) {
          this.$message.warning(this.$t('SeaExport.DataCategoryProcessingFailed'))
        } else {
          const failCount = notOperateJobNos.length + blockJobNos.length + hblLockJobNos.length
          let msg = this.$t(clearCheck ? 'SeaExport.PartSuccessClearXThePieces' : 'SeaExport.PartSuccessCheckXThePieces', [successJobNos.length, failCount])
          if (notOperateJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisNotPositiveOperation', [notOperateJobNos.join(',')])
          }
          if (blockJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisBlocked', [blockJobNos.join(',')])
          }
          if (hblLockJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisHblLock', [hblLockJobNos.join(',')])
          }
          this.failDialog.content = msg
          this.failDialog.jobNos = [...notOperateJobNos, ...blockJobNos, ...hblLockJobNos].join(',')
          this.failDialog.visible = true
        }
      } finally {
        loading.close()
      }
    },
    getDataCategoryLabel() {
      let option = this.dataCategoris.find(p => p.value === this.dataCategory[0])
      if (option) {
        const lables = [option.label]
        for (let i = 1; i < this.dataCategory.length; ++i) {
          if (!option.children) {
            break
          }
          option = option.children.find(p => p.value === this.dataCategory[i])
          if (!option) {
            break
          }
          lables.push(option.label)
        }
        return lables.join(' / ')
      }
      return ''
    },
    async destinationPortServiceConfirmHandler() {
      const { checkState, clearCheck } = this.destinationPortService
      if (!checkState && !clearCheck) {
        this.$message.warning((this.$t('SeaExport.SelectAtLeastOneAdjustment')))
        return
      }
      const dataCategoryLabel = this.getDataCategoryLabel()
      if (clearCheck) {
        const flag = await this.$confirm(this.$t('SeaExport.ClearStateComfirm', [dataCategoryLabel]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.confirm'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      } else if (checkState) {
        const flag = await this.$confirm(this.$t('SeaExport.CheckStateComfirm', [dataCategoryLabel]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.confirm'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }
      const loading = getLoading4Cxt(this)
      try {
        const res = await batchUpdateDestinationPortService(this.jobKeys, this.dataCategoryValue, !clearCheck)
        const { successJobNos, notOperateJobNos, blockJobNos, hblLockJobNos, notMatchJobNos } = res.data
        if (successJobNos.length > 0) {
          this.hasUpdate = true
        }
        if (successJobNos.length === this.jobKeys.length) {
          if (clearCheck) {
            this.$message.success(this.$t('SeaExport.SuccessfullyCancelXPieces', [successJobNos.length]))
          } else {
            this.$message.success(this.$t('SeaExport.SuccessfullyCheckXPieces', [successJobNos.length]))
          }
          this.innerVisible = false
        } else if (notMatchJobNos.length > 0) {
          this.$message.warning(this.$t('SeaExport.DataCategoryProcessingFailed'))
        } else {
          const failCount = notOperateJobNos.length + blockJobNos.length + hblLockJobNos.length
          let msg = this.$t(clearCheck ? 'SeaExport.PartSuccessClearXThePieces' : 'SeaExport.PartSuccessCheckXThePieces', [successJobNos.length, failCount])
          if (notOperateJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisNotPositiveOperation', [notOperateJobNos.join(',')])
          }
          if (blockJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisBlocked', [blockJobNos.join(',')])
          }
          if (hblLockJobNos.length > 0) {
            msg += '\n' + this.$t('SeaExport.BusinessisCargoDocLock', [hblLockJobNos.join(',')])
          }
          this.failDialog.content = msg
          this.failDialog.jobNos = [...notOperateJobNos, ...blockJobNos, ...hblLockJobNos].join(',')
          this.failDialog.visible = true
        }
      } finally {
        loading.close()
      }
    },
    async destinationAgentConfirmHandler() {
      if (!this.destinationAgent && !this.clearByBusiness) {
        this.$message.warning(this.$t('SeaExport.adjustedDestinationAgent'))
        return
      }
      const flag = await this.$confirm(this.$t('SeaExport.whetherCoverMBLReceiver'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Cover'),
        cancelButtonText: this.$t('CargoMsg.Cargo_NotCover'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => true).catch(() => false)
      const loading = getLoading4Cxt(this)
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        keys: this.jobKeys,
        lob: this.lob,
        coverMblReceiver: flag,
        destinationAgent: this.destinationAgent
      }
      await batchUpdateDestinationAgentFunc(params).then(res => {
        const { successJobNos, jobStateJobNos, notMasterJobNos } = res.data
        if (jobStateJobNos.length > 0 || notMasterJobNos.length > 0) {
          const jobNos = jobStateJobNos.join(',')
          const masterJobNos = notMasterJobNos.join(',')
          const failLength = jobStateJobNos.length + notMasterJobNos.length
          this.$message.warning({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip2', [successJobNos.length, failLength, jobNos, masterJobNos]) })
        } else {
          this.$message.success({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip', [successJobNos.length]) })
        }
        this.innerVisible = false
      }).catch().finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    async carryingCmpConfirmHandler() {
      if (!this.carryingCmp) {
        this.$message.warning(this.$t('SeaExport.hasOneCategoryAtleast'))
        return
      }
      // 门点装箱/提货校验：存在任意一条未勾选的订单，不允许调整运输公司
      // 先用列表数据做前置校验；若列表未带 landTransportation，则以后端返回的拦截结果为准
      const abnormalJobs = this.jobList.filter(p => Object.prototype.hasOwnProperty.call(p, 'landTransportation') && !p.landTransportation)
      if (abnormalJobs.length > 0) {
        this.carryingCmpBlockDialog.jobNos = abnormalJobs.map(p => p.jobNo || p.uuid)
        this.carryingCmpBlockDialog.visible = true
        return
      }
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      const flag = await this.$confirm(this.$t('SeaExport.changeOneConfirm', [item.label]), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }
      const loading = getLoading4Cxt(this)
      const params = {
        keys: this.jobKeys,
        lob: this.lob,
        carryingCmp: this.carryingCmp
      }
      await batchUpdateCarryingCmpFunc(params).then(res => {
        const data = res.data || {}
        // 后端兜底：存在未勾选门点装箱/提货，展示异常业务编号弹窗
        const blockedJobNos = data.landTransportBlockedJobNos || []
        if (blockedJobNos.length > 0) {
          this.carryingCmpBlockDialog.jobNos = blockedJobNos
          this.carryingCmpBlockDialog.visible = true
          return
        }
        const successJobNos = data.successJobNos || []
        const failJobNos = data.failJobNos || []
        if (failJobNos.length > 0) {
          const jobNos = failJobNos.join(',')
          this.$message.warning({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip1', [successJobNos.length, failJobNos.length, jobNos]) })
        } else {
          this.$message.success({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip', [successJobNos.length]) })
        }
        this.hasUpdate = true
        this.innerVisible = false
      }).catch().finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.seaExport && item.active
    },
    async userDefinedFieldHandler(index, value) {
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      if (!value) {
        this.$message.warning(this.$t('SeaExport.hasOneCategoryAtleast'))
        return
      }
      // 是否包含小票
      // if (index === 'mblNo' || index === 'voyageFlight' || index === 'etd' || index === 'eta') {
      //   for (const job of this.jobList) {
      //     if (job.lclMasterUuid && job.lclMasterUuid.length > 0) {
      //       this.$message.warning(this.$t('SeaExport.lclSlavesJobCannotModify'))
      //       return
      //     }
      //   }
      // }

      if (index === 'mblNo' && (!await this.mblCheckHandler())) {
        return
      }
      const flag = await this.$confirm(this.$t('SeaExport.changeOneConfirm', [item.label]), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }
      const loading = getLoading4Cxt(this)
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        keys: this.jobKeys,
        lob: this.lob,
        fieldName: index,
        fieldValue: value
      }
      await batchUpdateAeJob(params).then(res => {
        const { successJobNos, jobStateJobNos } = res.data
        if (jobStateJobNos.length > 0) {
          const jobNos = jobStateJobNos.join(',')
          this.$message.warning({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip1', [successJobNos.length, jobStateJobNos.length, jobNos]) })
        } else {
          this.$message.success({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip', [successJobNos.length]) })
        }
        this.innerVisible = false
      }).catch().finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    async updateWarehouseDataConfirmHandler() {
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      if (!this.isOpenWarehouse) {
        if (!this.warehouseCmp) {
          this.$message.warning(this.$t('SeaExport.hasOneCategoryAtleast'))
          return
        }
      } else {
        if (!this.warehouseCmp || !this.warehouseName) {
          this.$message.warning(this.$t('SeaExport.hasOneCategoryAtleast'))
          return
        }
      }
      const flag = await this.$confirm(this.$t('SeaExport.changeOneConfirm', [item.label]), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }

      const loading = getLoading4Cxt(this)
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        keys: this.jobKeys,
        lob: this.lob,
        anyInteger: this.warehouseCmp,
        anyStr: this.warehouseName
      }
      await batchUpdateAeJobWarehouse(params).then(res => {
        const { successJobNos, jobStateJobNos } = res.data
        if (jobStateJobNos.length > 0) {
          const jobNos = jobStateJobNos.join(',')
          this.$message.warning({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip1', [successJobNos.length, jobStateJobNos.length, jobNos]) })
        } else {
          this.$message.success({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip', [successJobNos.length]) })
        }
        this.innerVisible = false
      }).catch().finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    async updateCarrierIdConfirmHandler() {
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      if (!this.carrierId) {
        this.$message.warning(this.$t('SeaExport.hasOneCategoryAtleast'))
        return
      }
      // 是否包含小票
      // for (const job of this.jobList) {
      //   if (job.lclMasterUuid && job.lclMasterUuid.length > 0) {
      //     this.$message.warning(this.$t('SeaExport.lclSlavesJobCannotModify'))
      //     return
      //   }
      // }
      const flag = await this.$confirm(this.$t('SeaExport.changeOneConfirm', [item.label]), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }
      const loading = getLoading4Cxt(this)
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        keys: this.jobKeys,
        lob: this.lob,
        anyInteger: this.carrierId
      }
      await batchUpdateAeJobCarrierId(params).then(res => {
        const { successJobNos, jobStateJobNos } = res.data
        if (jobStateJobNos.length > 0) {
          const jobNos = jobStateJobNos.join(',')
          this.$message.warning({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip1', [successJobNos.length, jobStateJobNos.length, jobNos]) })
        } else {
          this.$message.success({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip', [successJobNos.length]) })
        }
        this.innerVisible = false
      }).catch().finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    async warehouseChangeHandler(value) {
      if (!value || value === 0) {
        return
      }
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(value))
      if (!companyCache) return

      this.warehouseNameList = []
      await getWarehouseDetail(companyCache.uuid).then(async res => {
        if (res.data.length > 0) {
          this.warehouseNameList = res.data
        }
      })
    },
    async mblCheckHandler() {
      // if (flg) {
      //   await this.mblChangeCallback()
      // }
      const mblPrefix = this.$refs.mawbNoInput.prefix.trim()
      for (const job of this.jobList) {
        if (mblPrefix) {
          const airline = await this.getPartnerAirline(job.carrierId)
          const mawbprefix = airline.mawbprefix.trim()
          if (mawbprefix && mawbprefix !== mblPrefix) {
            this.$message.warning(job.jobNo + this.$t('queryJob.EnteredXNotMatchAirlinePrefix', [mblPrefix]))
            return true
          }
        }
        if ((job.bookingTerm === BookingTerm.DB_BOOKING_TYPE.code || Number(cache.config.get('AEAllowInputMBL')) === 1) &&
          !AirExportUtils.validateMAWBNumIgnoreZeroOrThree(this.mblNo)) {
          this.$message.warning(this.$t('queryJob.TheIsIllegalPleaseEnter'))
          return false
        }
      }
      return true
    },
    // 获取合作伙伴航空公司信息
    async getPartnerAirline(cmpIdx) {
      const airline = { cmpIdx, airlineCode: '', mawbprefix: '' }
      const cmp = Company.getCompanyByIdSync(cmpIdx)
      if (cmp) {
        await getAirlineList({ companyUuid: cmp.uuid }).then(res => {
          if (res.data.list.length > 0) {
            Object.assign(airline, res.data.list[0])
          }
        })
      }
      return airline
    },
    async batchUpdateJobData() {
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      if (!this.remarks) {
        this.$message.warning(this.$t('SeaExport.hasOneCategoryAtleast'))
        return
      }
      const flag = await this.$confirm(this.$t('SeaExport.changeOneConfirm', [item.label]), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }
      const loading = getLoading4Cxt(this)
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        keys: this.jobKeys,
        lob: this.lob,
        remarks: this.remarks
      }
      await batchUpdateJobDataFunc(params).then(res => {
        const { successJobNos, jobStateJobNos } = res.data
        if (jobStateJobNos.length > 0) {
          const jobNos = jobStateJobNos.join(',')
          this.$message.warning({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip1', [successJobNos.length, jobStateJobNos.length, jobNos]) })
        } else {
          this.$message.success({ dangerouslyUseHTMLString: true, message: this.$t('CargoMsg.Cargo_SuccessTip', [successJobNos.length]) })
        }
        this.innerVisible = false
      }).catch().finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    async bookingAgentConfirmHandler() {
      const item = this.dataCategoris.find(p => p.value === this.dataCategoryValue)
      if (!this.bookingAgent) {
        this.$message.warning(this.$t('SeaExport.hasOneCategoryAtleast'))
        return
      }
      const flag = await this.$confirm(this.$t('SeaExport.changeOneConfirm', [item.label]), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }
      const loading = getLoading4Cxt(this)
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        keys: this.jobKeys,
        lob: this.lob,
        bookingAgent: this.bookingAgent
      }
      await validateBatchBookingAgent(params).then(async res => {
        const data = res.data
        let flag = false
        if (data.existsBookingAgentAgree) {
          flag = await this.$confirm(this.$t('SeaExport.hasRefreshCharge'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
            cancelButtonText: this.$t('CargoMsg.Cargo_No'),
            distinguishCancelAndClose: true,
            type: 'warning'
          }).then(() => true).catch(() => false)
        }

        const updateParams = {
          branchId: this.$store.getters.currentOfficeId,
          keys: this.jobKeys,
          lob: this.lob,
          updateCharge: flag,
          bookingAgent: this.bookingAgent
        }
        await batchUpdateBookingAgent(updateParams).then(res => {
          const { successJobNos, chargeStateJobNos } = res.data
          if (chargeStateJobNos.length > 0) {
            const jobNos = chargeStateJobNos.join(',')
            this.$message.warning({ dangerouslyUseHTMLString: true, message: this.$t('SeaExport.successTipAlreadyNotEditCharge', [successJobNos.length, jobNos]) })
          } else {
            this.$message.success({ dangerouslyUseHTMLString: true, message: this.$t('SeaExport.SuccessTip', [successJobNos.length]) })
          }
          this.innerVisible = false
        }).catch().finally(() => {
          if (loading) {
            loading.close()
          }
        })
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    }
  }
}
</script>
